<div fxLayout="column">
  <div fxLayout="row" style="font-size: 20px">Country configuration</div>

  <div fxLayout="row" style="padding-top: 20px">
    <mat-form-field appearance="fill" fxFlex="80">
      <mat-label>Country</mat-label>
      <mat-select
        [(ngModel)]="country"
        required
        (selectionChange)="selectCountry($event)"
      >
        <mat-option
          *ngFor="let country_lst of country_list"
          [value]="country_lst.countryId"
        >
          {{ country_lst.countryName }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div fxLayout="row" style="padding-top: 16px">
    <mat-form-field fxFlex="80">
      <mat-label>Secondary language </mat-label>
      <input matInput [(ngModel)]="secondry_lang" [readonly]="true" />
    </mat-form-field>
  </div>
  <div class="button-container">
    <button
      mat-button
      (click)="save()"
      color="accent"
      class="example-button-row"
      type="button"
      [disabled]="button_flag"
    >
      SAVE
    </button>
    <!-- <button
      mat-button
      (click)="cancel()"
      class="example-button-row"
      class="button-style"
    >
      CANCEL
    </button> -->
  </div>
</div>
